import apiClient from "../../utils/apiClient";

const getAnnouncements = () => {
    return apiClient.get('announcements');
}

export const announcementService = {
    getAnnouncements
};